'use strict';

var index = require('./index-5c01eb62.js');
var lib = require('./lib-75591456.js');
var definitions = require('./definitions-4ae1604d.js');
var styleInject_es = require('./style-inject.es-71b52b81.js');

var css_248z = ".Hideable--slideleft,\n.Hideable--slideright,\n.Hideable--nudgeup,\n.Hideable--nudgedown {\n  transition-property: opacity, transform;\n  will-change: opacity, transform;\n}\n\n.Hideable--slideleft {\n  transform: translateX(-100%);\n}\n\n.Hideable--slideright {\n  transform: translateX(100%);\n}\n\n.Hideable--nudgeup {\n  transform: translateY(-0.25rem);\n}\n\n.Hideable--nudgedown {\n  transform: translateY(0.25rem);\n}\n\n.Hideable--slideleft.Hideable--visible,\n.Hideable--slideright.Hideable--visible,\n.Hideable--nudgeup.Hideable--visible,\n.Hideable--nudgedown.Hideable--visible {\n  transform: none;\n}\n";
styleInject_es.styleInject(css_248z);

var SlowReveal = lib.variant('SlowReveal', index.Hideable, {
    speed: definitions.Speed.Slow,
    delayIn: definitions.Delay.Short,
});
var SlideLeft = lib.variant('SlideLeft', index.Hideable, {
    speed: definitions.Speed.Slow,
    fade: false,
});
var SlideRight = lib.variant('SlideRight', index.Hideable, {
    speed: definitions.Speed.Slow,
    fade: false,
});
var NudgeUp = lib.variant('NudgeUp', index.Hideable);
var NudgeDown = lib.variant('NudgeDown', index.Hideable);
var RollerBlind = lib.variant('RollerBlind', index.Hideable, {
    speed: definitions.Speed.Slow,
    collapse: definitions.Axis.Y,
});

exports.NudgeDown = NudgeDown;
exports.NudgeUp = NudgeUp;
exports.RollerBlind = RollerBlind;
exports.SlideLeft = SlideLeft;
exports.SlideRight = SlideRight;
exports.SlowReveal = SlowReveal;
//# sourceMappingURL=variants-795e2d27.js.map
